// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { EnumMapRule, EnumMapRuleT, verifyEnumMapRule } from "./enum-map-rule";
import { EventKey, EventKeyT } from "./event-key";
import { FlagRule, FlagRuleT, verifyFlagRule } from "./flag-rule";
import { IgnoreRule, IgnoreRuleT, verifyIgnoreRule } from "./ignore-rule";
import { RecordRule, RecordRuleT, verifyRecordRule } from "./record-rule";
import { Rule, unionToRule, unionListToRule } from "./rule";
import { TransformRule, TransformRuleT, verifyTransformRule } from "./transform-rule";
import { ValuedRule, ValuedRuleT, verifyValuedRule } from "./valued-rule";

/**
 * An override of one event row, matched by exact key.
 */
export class EventOverride implements flatbuffers.IUnpackableObject<EventOverrideT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): EventOverride {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsEventOverride(bb: flatbuffers.ByteBuffer, obj?: EventOverride): EventOverride {
    return (obj || new EventOverride()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsEventOverride(
    bb: flatbuffers.ByteBuffer,
    obj?: EventOverride,
  ): EventOverride {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new EventOverride()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  key(obj?: EventKey): EventKey | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? (obj || new EventKey()).__init(this.bb_pos + offset, this.bb!) : null;
  }

  ruleType(): Rule {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : Rule.NONE;
  }

  rule<T extends flatbuffers.Table>(obj: any): any | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.__union(obj, this.bb_pos + offset) : null;
  }

  note(): string | null;
  note(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  note(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  static startEventOverride(builder: flatbuffers.Builder) {
    builder.startObject(4);
  }

  static addKey(builder: flatbuffers.Builder, keyOffset: flatbuffers.Offset) {
    builder.addFieldStruct(0, keyOffset, 0);
  }

  static addRuleType(builder: flatbuffers.Builder, ruleType: Rule) {
    builder.addFieldInt8(1, ruleType, Rule.NONE);
  }

  static addRule(builder: flatbuffers.Builder, ruleOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, ruleOffset, 0);
  }

  static addNote(builder: flatbuffers.Builder, noteOffset: flatbuffers.Offset) {
    builder.addFieldOffset(3, noteOffset, 0);
  }

  static endEventOverride(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // key
    builder.requiredField(offset, 8); // rule
    return offset;
  }

  static createEventOverride(
    builder: flatbuffers.Builder,
    keyOffset: flatbuffers.Offset,
    ruleType: Rule,
    ruleOffset: flatbuffers.Offset,
    noteOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    EventOverride.startEventOverride(builder);
    EventOverride.addKey(builder, keyOffset);
    EventOverride.addRuleType(builder, ruleType);
    EventOverride.addRule(builder, ruleOffset);
    EventOverride.addNote(builder, noteOffset);
    return EventOverride.endEventOverride(builder);
  }

  unpack(): EventOverrideT {
    return new EventOverrideT(
      this.key() !== null ? this.key()!.unpack() : null,
      this.ruleType(),
      (() => {
        const temp = unionToRule(this.ruleType(), this.rule.bind(this));
        if (temp === null) {
          return null;
        }
        return temp.unpack();
      })(),
      this.note(),
    );
  }

  unpackTo(_o: EventOverrideT): void {
    _o.key = this.key() !== null ? this.key()!.unpack() : null;
    _o.ruleType = this.ruleType();
    _o.rule = (() => {
      const temp = unionToRule(this.ruleType(), this.rule.bind(this));
      if (temp === null) {
        return null;
      }
      return temp.unpack();
    })();
    _o.note = this.note();
  }

  unpackFields(...fields: string[]): EventOverrideT {
    const t = new EventOverrideT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("key")) {
      t.key = this.key() !== null ? this.key()!.unpack() : null;
    }
    if (fieldSet.has("rule_type")) {
      t.ruleType = this.ruleType();
    }
    if (fieldSet.has("rule")) {
      t.rule = (() => {
        const temp = unionToRule(this.ruleType(), this.rule.bind(this));
        if (temp === null) {
          return null;
        }
        return temp.unpack();
      })();
    }
    if (fieldSet.has("note")) {
      t.note = this.note();
    }
    return t;
  }
}

export class EventOverrideT implements flatbuffers.IGeneratedObject {
  constructor(
    public key: EventKeyT | null = null,
    public ruleType: Rule = Rule.NONE,
    public rule:
      | EnumMapRuleT
      | FlagRuleT
      | IgnoreRuleT
      | RecordRuleT
      | TransformRuleT
      | ValuedRuleT
      | null = null,
    public note: string | Uint8Array | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.key === null || this.key === undefined) {
      throw new Error('Required field "key" is not set');
    }
    if (this.rule === null || this.rule === undefined) {
      throw new Error('Required field "rule" is not set');
    }
    const rule = builder.createObjectOffset(this.rule);
    const note = this.note !== null ? builder.createString(this.note!) : 0;

    return EventOverride.createEventOverride(
      builder,
      this.key !== null ? this.key!.pack(builder) : 0,
      this.ruleType,
      rule,
      note,
    );
  }

  clone(): EventOverrideT {
    const obj = new EventOverrideT();
    obj.key = this.key !== null ? this.key!.clone() : null;
    obj.ruleType = this.ruleType;
    obj.rule =
      this.rule !== null && typeof (this.rule as any).clone === "function"
        ? (this.rule as any).clone()
        : this.rule;
    obj.note = this.note;
    return obj;
  }

  equals(other: EventOverrideT): boolean {
    if (this.key !== null && other.key !== null) {
      if (!this.key!.equals(other.key!)) return false;
    } else if (this.key !== other.key) return false;
    if (this.ruleType !== other.ruleType) return false;
    if (this.rule !== null && other.rule !== null) {
      if (typeof (this.rule as any).equals === "function") {
        if (!(this.rule as any).equals(other.rule)) return false;
      } else if (this.rule !== other.rule) return false;
    } else if (this.rule !== other.rule) return false;
    if (this.note !== other.note) return false;
    return true;
  }
}

export function verifyEventOverride(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 8);
    verifier.checkRequiredField(tablePos, 4, "key");
    verifier.checkScalarField(tablePos, 6, 1);
    verifier.checkUnionConsistency(tablePos, 6, 8, "rule");
    {
      const pos = verifier.checkOffsetField(tablePos, 8);
      if (pos !== 0) {
        const uType = verifier.readFieldUint8(tablePos, 6);
        switch (uType) {
          case 1: // IgnoreRule
            {
              const o = verifier.readInt32(pos);
              verifyIgnoreRule(verifier, pos + o);
            }
            break;
          case 2: // FlagRule
            {
              const o = verifier.readInt32(pos);
              verifyFlagRule(verifier, pos + o);
            }
            break;
          case 3: // ValuedRule
            {
              const o = verifier.readInt32(pos);
              verifyValuedRule(verifier, pos + o);
            }
            break;
          case 4: // EnumMapRule
            {
              const o = verifier.readInt32(pos);
              verifyEnumMapRule(verifier, pos + o);
            }
            break;
          case 5: // RecordRule
            {
              const o = verifier.readInt32(pos);
              verifyRecordRule(verifier, pos + o);
            }
            break;
          case 6: // TransformRule
            {
              const o = verifier.readInt32(pos);
              verifyTransformRule(verifier, pos + o);
            }
            break;
        }
      }
    }
    verifier.checkRequiredField(tablePos, 8, "rule");
    {
      const pos = verifier.checkOffsetField(tablePos, 10);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
  } finally {
    verifier.popDepth();
  }
}
